import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-sem-server-unavailable',
  standalone: false,
  styles: [`
    .server-unavailable {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 60vh;
      padding: 40px 20px;
      text-align: center;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      color: #333;
    }
    .icon {
      font-size: 64px;
      margin-bottom: 20px;
      opacity: 0.6;
    }
    h2 {
      margin: 0 0 12px;
      font-size: 24px;
      font-weight: 600;
      color: #c0392b;
    }
    p {
      margin: 0 0 8px;
      font-size: 15px;
      color: #666;
      max-width: 500px;
      line-height: 1.5;
    }
    .retry-btn {
      margin-top: 24px;
      padding: 10px 28px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      background: #2980b9;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: background 0.2s;
    }
    .retry-btn:hover {
      background: #1f6da0;
    }
  `],
  template: `
    <div class="server-unavailable">
      <div class="icon">&#9888;</div>
      <h2>Server Unavailable</h2>
      <p>The backend server is not responding. Please make sure the API server is running and try again.</p>
      <p style="font-size: 13px; color: #999;">If this is a development environment, start the backend project first.</p>
      <button class="retry-btn" (click)="retry()">Retry</button>
    </div>
  `
})
export class SemServerUnavailableComponent implements OnInit {
  private returnUrl: string | null = null;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
  }

  retry() {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
    } else {
      window.location.reload();
    }
  }
}
